module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_intro-heading01-pc-9e65f7ce7dfbd3abeb2dc6b94ce222fc.png";